import {Injectable, NgZone} from '@angular/core';
import {PLANTILLA} from '@app/config/plantilla';

export interface BrowserNotificationOptions {
    title: string;
    body?: string;
    tag?: string;
    onClick?: () => void;
}

@Injectable({
    providedIn: 'root'
})
export class BrowserNotificationService {

    private readonly iconUrl = PLANTILLA.favicon;

    constructor(private ngZone: NgZone) {
    }

    get isSupported(): boolean {
        return typeof window !== 'undefined' && 'Notification' in window;
    }

    get permission(): NotificationPermission | 'unsupported' {
        return this.isSupported ? Notification.permission : 'unsupported';
    }

    get canRequestPermission(): boolean {
        return this.permission === 'default';
    }

    get isEnabled(): boolean {
        return this.permission === 'granted';
    }

    get isBlocked(): boolean {
        return this.permission === 'denied';
    }

    requestPermission(): Promise<NotificationPermission | 'unsupported'> {
        if (!this.isSupported) {
            return Promise.resolve('unsupported');
        }
        if (Notification.permission !== 'default') {
            return Promise.resolve(Notification.permission);
        }
        return Notification.requestPermission();
    }

    show(options: BrowserNotificationOptions): void {
        if (!this.isEnabled || !options?.title) {
            return;
        }
        try {
            const notification = new Notification(options.title, {
                body: options.body || '',
                icon: this.iconUrl,
                badge: this.iconUrl,
                tag: options.tag,
                silent: true // la app ya reproduce su propio sonido; evita el doble aviso sonoro del SO
            });
            notification.onclick = () => {
                window.focus();
                notification.close();
                if (options.onClick) {
                    this.ngZone.run(options.onClick);
                }
            };
        } catch (e) {
            // En navegadores moviles el constructor Notification requiere service worker y lanza error.
        }
    }
}
